// Tarayıcının yerel bugünü 'yyyy-MM-dd' (testlerde sabitlenir: jest.mock('./clock')).
export const todayIso = () => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};
